<template>
  <div
    v-if="!materials && !washInstructions && !symbols.length"
    class="flex items-center gap-7 py-4"
  >
    {{ $t('pdp.product_details_no_info') }}
  </div>

  <!-- Materials -->
  <div v-if="materials" class="flex flex-col py-4">
    <span class="text-md mb-1 font-normal leading-5 md:text-lg md:leading-6">
      {{ $t('pdp.product_details_material') }}:
    </span>
    <p class="text-base font-normal leading-4 md:text-base md:leading-5">
      {{ materials }}
    </p>
  </div>

  <!-- Wash Instructions -->
  <div v-if="washInstructions" class="flex flex-col py-4">
    <span class="text-md mb-1 font-normal leading-5 md:text-lg md:leading-6">
      {{ $t('pdp.product_details_wash_instructions') }}:
    </span>
    <p
      class="text-base font-normal capitalize leading-4 md:text-base md:leading-5"
    >
      {{ washInstructions }}
    </p>
  </div>

  <!-- Care Symbols -->
  <div
    v-if="symbols.length"
    class="flex items-center gap-7 py-4 text-base font-normal leading-5 md:text-lg md:leading-6"
  >
    <span class="text-md mb-1 font-normal leading-5 md:text-lg md:leading-6">
      {{ $t('pdp.product_details_care') }}:</span
    >
    <ProductCareSymbols :symbols="symbols" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { PropType } from 'vue'
import { getFirstAttributeValue, type Product } from '@scayle/storefront-nuxt'
import { getAdvancedAttributeFirstValue } from '../../../../utils/advancedAttribute'
import { careSymbols } from '~/config/careSymbols'

const props = defineProps({
  product: {
    type: Object as PropType<Product | null>,
    default: () => null,
  },
})

const materials = computed(() =>
  getAdvancedAttributeFirstValue(props.product, 'material'),
)

const washInstructions = computed(
  () => getFirstAttributeValue(props.product?.attributes, 'washComment')?.label,
)

const symbols = computed<string[]>(() =>
  [
    'caresymbolWash',
    'caresymbolBleaching',
    'caresymbolDry',
    'caresymbolIron',
    'caresymbolClean',
  ]
    .map(
      (attribute: string) =>
        getFirstAttributeValue(props.product?.attributes, attribute)?.value,
    )
    .filter((i): i is string => Boolean(i))
    .filter((i) => careSymbols[i]),
)
</script>
